// Pendo event tracking properties
export interface ColumnCounts {
  defaultHiddenCount: number
  rowPropertiesCount: number
}

export enum RowPropertyName {
  'cvId' = 'cvId',
  'createdAt' = 'createdAt',
  'createdBy' = 'createdBy',
  'updatedAt' = 'updatedAt',
  'updatedBy' = 'updatedBy',
  'submission' = 'submission',
}

export type DbColumnName =
  | 'cv_id'
  | 'properties.createdAt'
  | 'properties.createdById'
  | 'properties.updatedAt'
  | 'properties.updatedById'
  | 'properties.submissionId'

export interface Alias {
  display: string
  db: DbColumnName
}

export interface Field {
  description: string | null
  fieldId: number
  governanceType: string
  name: string
  precedence: number | null
  required: boolean
  visible: boolean
  rowPropertyName?: RowPropertyName
  defaultHidden?: boolean
  isClassificationColumn?: boolean
}

export type FieldTuple = [Field[], Field[]]

export type Selected = Record<string, boolean>

export interface State {
  fieldsExpanded: boolean
  propertiesExpanded: boolean
  popoverOpen: boolean
  rowProperties: Field[]
  searchResults: Field[]
  searchTerm: string
  selectAllFields: boolean
  allColumns: Field[]
  selectAllProperties: boolean
  selected: Selected
  creativeClassificationsExpanded: boolean
}

export enum ActionType {
  clearSearch = 'clearSearch',
  resetToDefault = 'resetToDefault',
  resetToInitialState = 'resetToInitialState',
  setFieldsExpanded = 'setFieldsExpanded',
  setPropertiesExpanded = 'setPropertiesExpanded',
  setPopoverOpen = 'setPopoverOpen',
  setSearchResults = 'setSearchResults',
  selectFields = 'selectFields',
  selectCreativeClassifications = 'selectCreativeClassifications',
  selectProperties = 'selectProperties',
  setSelected = 'setSelected',
  updateInitialValues = 'updateInitialValues',
  setCreativeClassificationsExpanded = 'setCreativeClassificationsExpanded',
}

export type Action =
  | {
      type: ActionType.clearSearch
      payload: {
        searchTerm: string
        selected: Selected
      }
    }
  | {
      type: ActionType.resetToDefault
      payload: Field[]
    }
  | {
      type: ActionType.resetToInitialState
    }
  | {
      type: ActionType.setFieldsExpanded
    }
  | {
      type: ActionType.setCreativeClassificationsExpanded
    }
  | {
      type: ActionType.setPropertiesExpanded
    }
  | {
      type: ActionType.setPopoverOpen
      payload: boolean
    }
  | {
      type: ActionType.setSearchResults
      payload: { searchTerm: string }
    }
  | {
      type: ActionType.setSelected
      payload: {
        fieldId: number
        checked: boolean
        rowPropertyName?: RowPropertyName
      }
    }
  | {
      type: ActionType.selectFields
      payload: Field[]
    }
  | {
      type: ActionType.selectCreativeClassifications
      payload: Field[]
    }
  | {
      type: ActionType.selectProperties
      payload: Field[]
    }
  | {
      type: ActionType.updateInitialValues
      payload: {
        rowProperties: Field[]
        selected: Selected
        allColumns: Field[]
      }
    }
